import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { EnglishOnly } from "@outschool/ui-components-website";
import {
  ImpressionTracking,
  TrackingPageSection,
} from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
/* eslint-disable i18next/no-literal-string */
import React from "react";

import curatedTutoringFrame from "../../../../images/curated-tutoring-frame.png";
import curatedTutoringFrameMobile from "../../../../images/curated-tutoring-mobile-frame.png";
import curatedWhatIsOutschoolFrameMobile from "../../../../images/curated-what-is-outschool-frame-mobile.svg";
import curatedWhatIsOutschoolFrame from "../../../../images/curated-what-is-outschool-frame.svg";
import MuxVideoPlayer from "../../MuxVideoPlayer";

export default function CuratedWhatIsOutschool({
  isTutoringCLP,
}: {
  isTutoringCLP: boolean;
}) {
  const isMobile = useIsMobile();
  const { t } = useTranslation(
    "client\\components\\categories\\CuratedWhatIsOutschool",
  );

  const imageSource = isTutoringCLP
    ? isMobile
      ? curatedTutoringFrameMobile
      : curatedTutoringFrame
    : isMobile
    ? curatedWhatIsOutschoolFrameMobile
    : curatedWhatIsOutschoolFrame;
  return (
    <EnglishOnly>
      <TrackingPageSection
        name="curated_how_it_works_video_section"
        uniqueId="curated_how_it_works_video_section"
      >
        {setImpressionNode => (
          <Box
            ref={setImpressionNode}
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: isMobile ? "center" : "end",
              alignItems: isMobile ? "end" : "center",
              marginBottom: "50px",
            }}
          >
            <img
              style={{
                width: "100%",
                padding: 0,
                margin: 0,
                maxWidth: isMobile ? "560px" : "none",
              }}
              src={imageSource}
              alt={t`What Is Outschool`}
            />
            <ImpressionTracking
              trackingLabel="curated_how_it_works_video"
              uniqueId="curated_how_it_works_video"
              trackingEventName="curated_how_it_works_video_played"
            >
              {/* @ts-ignore TS(2322): Type '({ setNode, trackTouch }: { setNode: React.R... Remove this comment to see the full error message */}
              {({
                setNode,
                trackTouch,
              }: {
                setNode: React.Ref<HTMLDivElement>;
                trackTouch: () => void;
              }) => (
                <Box
                  sx={{
                    position: "absolute",
                    bottom: isMobile ? "5%" : "",
                    right: isMobile ? "" : "5%",
                    maxWidth: isMobile ? "560px" : "50%",
                  }}
                  ref={setNode}
                >
                  <MuxVideoPlayer
                    playButtonType="white-center"
                    videoPlaybackID={
                      isTutoringCLP
                        ? "UTYVhdOVCY9bavBIDFk6Hm02UcaxaJtkJ"
                        : "iPWZ01J69A6HCR99IVXV3WYMJ1f00SDfmt"
                    }
                    thumbnailUrl={
                      "https://image.mux.com/iPWZ01J69A6HCR99IVXV3WYMJ1f00SDfmt/thumbnail.jpg?time=1&height=318&width=566"
                    }
                    onClick={trackTouch}
                    sx={{
                      borderRadius: "xlarge",
                      // When the thumbnail is loading, the container has no height.
                      // This makes the play button float in space at the top of the render area.
                      // Hide overflow so this button is not visible during thumbnail load.
                      overflow: "hidden",
                    }}
                  />
                </Box>
              )}
            </ImpressionTracking>
          </Box>
        )}
      </TrackingPageSection>
    </EnglishOnly>
  );
}
